import { Component, Input, OnInit, OnDestroy } from "@angular/core";
import { MatListOption } from "@angular/material/list";
import { config as CONFIG } from "app/app.config";
import { DetalleContratistaComponent } from "app/main/apps/mantenedores/contratista/detalle-contratista/detalle-contratista.component";

import { PageContratistaDTO } from "app/main/apps/shared/interfaces/page-contratista.interface";
import { RegionComunaDTO } from "app/main/apps/shared/interfaces/region-comuna.interface";
import { CodigosService } from "app/main/apps/shared/services/rest/codigos.service";

import { ContratistaService } from "app/main/apps/shared/services/rest/contratista.service";
import { DialogService } from "app/main/apps/shared/services/rest/dialog.service";
import { finalize } from "rxjs/operators";
import { DialogInvitarComponent } from "../dialog-invitar/dialog-invitar.component";
//import { CatalogoService } from "app/main/apps/shared/services/rest/catalogo.service";
import { CategoriaDTO } from "app/main/apps/shared/interfaces/categoria.interface";
import { CodigoDTO } from "app/main/apps/shared/interfaces/codigo.interface";
import { MatSelectChange } from "@angular/material/select";
import { Subscription } from "rxjs";
import { OrdenesDeTrabajoService } from "app/main/apps/shared/services/rest/ordenes-de-trabajo.service";

@Component({
    selector: "app-listado-contratistas",
    templateUrl: "./listado-contratistas.component.html",
    styleUrls: ["./listado-contratistas.component.scss"],
})
export class ListadoContratistasComponent implements OnInit, OnDestroy {
    @Input() idGrupoServicio: number;
    @Input() descripcionGrupo: string;
    @Input() idComuna: number;
    @Input() idRegion: number;
    @Input() idOOTT: number;
    @Input() puedeAsignar: boolean;
    @Input() valorCotizado: number;

    grupo: CategoriaDTO;
    comuna: CodigoDTO;
    comunasRegion: RegionComunaDTO[];
    regiones: RegionComunaDTO[];
    evaluacionMinima: number = 0;
    pageContratistas: PageContratistaDTO;
    numeroRegistros: number;
    pagina: number;
    config;
    cargandoContratistas: boolean;
    subscripciones: Subscription;
    cambiarComuna: boolean;
    constructor(
        private _dialogSrvc: DialogService,
        private _contratistaSrvc: ContratistaService,
        private _codigosSrvc: CodigosService,
        //private _catalogoSrvc: CatalogoService,
        private _oottSrvc: OrdenesDeTrabajoService
    ) {
        this.cargandoContratistas = true;
        this.subscripciones = new Subscription();
        this.config = CONFIG;
        this.numeroRegistros = 5;
        this.pagina = 0;
    }

    ngOnInit(): void {
        this._codigosSrvc
            .fetchRegiones()
            .subscribe((regiones) => this.regiones);

        this._codigosSrvc
            .fetchComunasRegion(this.idRegion)
            .subscribe((comunasRegion) => {
                this.comunasRegion = comunasRegion;
                this.setComuna();
            });

        console.log(this.descripcionGrupo);

        // this._catalogoSrvc.fetchCatalogoServicios().subscribe((resp) => {
        //   console.log("filtro");
        if (this.idGrupoServicio !== 0) {
            this.grupo = {
                id: this.idGrupoServicio,
                descripcion: this.descripcionGrupo,
                atributos: null,
            };
            /*this._catalogoSrvc.getGrupo(
                    resp,
                    this.idGrupoServicio
                );*/
        } else {
            this.grupo = {
                id: 0,
                descripcion: "Otros servicios",
                atributos: [],
            };
        }
        //console.log("grupo", this.grupo);
        //});
        this.getContratistas();
    }

    setComuna() {
        this.comuna = this.comunasRegion.filter(
            (comuna) => comuna.id === this.idComuna
        )[0];
    }

    getContratistas() {
        //console.log("entro", this.grupo);
        this.cargandoContratistas = true;
        this.pageContratistas = null;
        this.subscripciones.add(
            this._contratistaSrvc
                .fetchContratistas(true, this.grupo.id, this.idComuna, 0, "", 0)
                .pipe(finalize(() => (this.cargandoContratistas = false)))
                .subscribe((resp) => (this.pageContratistas = resp))
        );
    }

    verFichaContratista(event, rutContratista: number) {
        event.stopPropagation();
        //console.log(rutContratista);
        this._dialogSrvc.abrirDialog(
            DetalleContratistaComponent,
            "clase-dialog",
            "800px",
            rutContratista
        );
    }

    siguiente() {
        this.pagina++;
        this.getContratistas();
    }

    anterior() {
        this.pagina--;
        this.getContratistas();
    }

    invitar(contratistasSeleccionados: MatListOption[]) {
        const contratistas = contratistasSeleccionados.map((c) => c.value);
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogInvitarComponent,
            "clase-dialog",
            "800px",
            {
                contratistas,
                idOOTT: this.idOOTT,
                valorCotizado: this.valorCotizado,
            }
        );

        dialogRef.afterClosed().subscribe((result) => {
            this._oottSrvc.oottsInvitacionesRefresh$.next(true);
            if (result) {
                //console.log("aviso cambio");
                //llamar a api para guardar los contratistas
                //refrescar tabla invitados contratistas
            }
        });
    }

    buscarContratristas(idComuna: MatSelectChange) {
        //console.log(idComuna);
        this.idComuna = idComuna.value;
        this.setComuna();
        this.cambiarComuna = false;
        this.pagina = 0;

        this.getContratistas();
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }

    getFoto(codigoFoto: string) {
        //console.log(codigoFoto);
        //this._usuarioSrvc.fetchFoto(codigoFoto).subscribe(blob=>{
        //    let url = window.URL.createObjectURL(blob);
        //    console.log(url);
        //    return this.sanitizer.bypassSecurityTrustUrl(url);
        //  })
    }
}
